import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [], // List of users
    searchUser: "", // Search query state
    selectedUser: null, // Currently selected user for chat
    isGroup: false, // Currently selected user for chat
    notiTotalCount: "",
  },
  reducers: {
    setUsers(state, action) {
      state.users = action.payload;
      state.filteredUsers = action.payload; // Initialize filteredUsers with full data
    },
    setSearchUser(state, action) {
      state.searchUser = action.payload;
    },
    selectUser(state, action) {
      state.selectedUser = action.payload;
    },
    setIsGroup(state, action) {
      state.isGroup = action.payload;
    },
    setNotiTotalCount(state, action) {
      state.notiTotalCount = action.payload;
    },
  },
});

export const {
  setUsers,
  setSearchUser,
  selectUser,
  setIsGroup,
  setNotiTotalCount,
} = userSlice.actions;
export default userSlice.reducer;
